// Auto generated file, do not manually modify!
// com.hotpads.cometuserauthdtos.userrole.CometUserRoleType

export enum CometUserRoleType {
  ACCEPTS_APPLICATIONS = 'ACCEPTS_APPLICATIONS',
  BLOCK_USERS = 'BLOCK_USERS',
  CHAT_BOT_BETA = 'CHAT_BOT_BETA',
  CHECKR_TAC = 'CHECKR_TAC',
  /**
   * @deprecated
   */
  CHECKR_TAC_LANDLORD = 'CHECKR_TAC_LANDLORD',
  /**
   * @deprecated
   */
  CHECKR_TAC_RENTER = 'CHECKR_TAC_RENTER',
  CIC_CONFIRMATION_RENTER = 'CIC_CONFIRMATION_RENTER',
  CIC_TAC = 'CIC_TAC',
  COMET_APPLICATIONS_USER = 'COMET_APPLICATIONS_USER',
  COMET_FEATURES_USER = 'COMET_FEATURES_USER',
  COMET_LEASES_USER = 'COMET_LEASES_USER',
  COMET_MAINTENANCE_USER = 'COMET_MAINTENANCE_USER',
  COMET_PAYMENTS_USER = 'COMET_PAYMENTS_USER',
  DELETE_LISTING = 'DELETE_LISTING',
  ENTERPRISE_DOWNGRADED_EXPERIENCE = 'ENTERPRISE_DOWNGRADED_EXPERIENCE',
  EXPERIAN_CIC_WRITTEN_CONSENT_RENTER = 'EXPERIAN_CIC_WRITTEN_CONSENT_RENTER',
  EXPERIAN_PRIVACY_POLICY = 'EXPERIAN_PRIVACY_POLICY',
  EXPERIAN_TAC = 'EXPERIAN_TAC',
  EXPERIAN_WRITTEN_CONSENT = 'EXPERIAN_WRITTEN_CONSENT',
  EXPERIAN_WRITTEN_CONSENT_LANDLORD = 'EXPERIAN_WRITTEN_CONSENT_LANDLORD',
  EXPERIAN_WRITTEN_CONSENT_RENTER = 'EXPERIAN_WRITTEN_CONSENT_RENTER',
  FEATURES_BETA = 'FEATURES_BETA',
  FEATURES_BETA_TAC = 'FEATURES_BETA_TAC',
  HOUSING_CONNECTOR = 'HOUSING_CONNECTOR',
  IMPERSONATE = 'IMPERSONATE',
  /**
   * @deprecated
   */
  LADMIN = 'LADMIN',
  /**
   * @deprecated
   */
  LADMIN_ADMIN = 'LADMIN_ADMIN',
  /**
   * @deprecated
   */
  LADMIN_CONSUMER_CARE = 'LADMIN_CONSUMER_CARE',
  /**
   * @deprecated
   */
  LADMIN_LAWYER = 'LADMIN_LAWYER',
  /**
   * @deprecated
   */
  LADMIN_SALES = 'LADMIN_SALES',
  /**
   * @deprecated
   */
  LDQ_MARKETING_USER = 'LDQ_MARKETING_USER',
  /**
   * @deprecated
   */
  LDQ_TIER_TWO_AND_THREE_USER = 'LDQ_TIER_TWO_AND_THREE_USER',
  LEASING_BETA = 'LEASING_BETA',
  MANAGE_ROLES = 'MANAGE_ROLES',
  /**
   * @deprecated
   */
  MARK_USERS_EMAIL_VERIFIED = 'MARK_USERS_EMAIL_VERIFIED',
  MULTIFAMILY_CUSTOMER = 'MULTIFAMILY_CUSTOMER',
  NON_ADVERTISER_CUSTOMER = 'NON_ADVERTISER_CUSTOMER',
  NUCLEUS_CUSTOMER = 'NUCLEUS_CUSTOMER',
  /**
   * @deprecated
   */
  PAYMENTS_BETA = 'PAYMENTS_BETA',
  PLAID_TAC = 'PLAID_TAC',
  POSTING_PATH_ADMIN = 'POSTING_PATH_ADMIN',
  PREMIUM_CUSTOMER = 'PREMIUM_CUSTOMER',
  PROPERTY_MANAGER_ADD_PROPERTY = 'PROPERTY_MANAGER_ADD_PROPERTY',
  PROPERTY_MANAGER_ALL_PROPERTIES = 'PROPERTY_MANAGER_ALL_PROPERTIES',
  PROPERTY_MANAGER_COMPANY_ADMIN = 'PROPERTY_MANAGER_COMPANY_ADMIN',
  PROPERTY_MANAGER_COMPANY_USER = 'PROPERTY_MANAGER_COMPANY_USER',
  PROPERTY_MANAGER_PAY_INVOICE = 'PROPERTY_MANAGER_PAY_INVOICE',
  PROPERTY_MANAGER_RESPOND_TO_REVIEW = 'PROPERTY_MANAGER_RESPOND_TO_REVIEW',
  PROPERTY_MANAGER_UPDATE_LISTING = 'PROPERTY_MANAGER_UPDATE_LISTING',
  PROPERTY_MANAGER_VIEW_ANALYTICS = 'PROPERTY_MANAGER_VIEW_ANALYTICS',
  PROPERTY_MANAGER_VIEW_INVOICE = 'PROPERTY_MANAGER_VIEW_INVOICE',
  PROPERTY_MANAGER_VIEW_MESSAGE = 'PROPERTY_MANAGER_VIEW_MESSAGE',
  ROCKET_SHIP_CUSTOMER = 'ROCKET_SHIP_CUSTOMER',
  SELF_SERVE_CUSTOMER = 'SELF_SERVE_CUSTOMER',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED = 'SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED = 'SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES = 'SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING = 'SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING',
  /**
   * @deprecated
   */
  SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING = 'SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING',
  SINGLE_FAMILY_LEGACY = 'SINGLE_FAMILY_LEGACY',
  SPOTLIGHT_CUSTOMER = 'SPOTLIGHT_CUSTOMER',
  TERMS_ACCEPTED_STRIPE = 'TERMS_ACCEPTED_STRIPE',
  TERMS_ZILLOW_RENTAL_USER = 'TERMS_ZILLOW_RENTAL_USER',
  ZILLOW_RENTAL_PLAID_CHECK_TERMS = 'ZILLOW_RENTAL_PLAID_CHECK_TERMS',
  ZILLOW_TAC = 'ZILLOW_TAC',
}

export const CometUserRoleType_values = [
  CometUserRoleType.ACCEPTS_APPLICATIONS,
  CometUserRoleType.BLOCK_USERS,
  CometUserRoleType.CHAT_BOT_BETA,
  CometUserRoleType.CHECKR_TAC,
  CometUserRoleType.CHECKR_TAC_LANDLORD,
  CometUserRoleType.CHECKR_TAC_RENTER,
  CometUserRoleType.CIC_CONFIRMATION_RENTER,
  CometUserRoleType.CIC_TAC,
  CometUserRoleType.COMET_APPLICATIONS_USER,
  CometUserRoleType.COMET_FEATURES_USER,
  CometUserRoleType.COMET_LEASES_USER,
  CometUserRoleType.COMET_MAINTENANCE_USER,
  CometUserRoleType.COMET_PAYMENTS_USER,
  CometUserRoleType.DELETE_LISTING,
  CometUserRoleType.ENTERPRISE_DOWNGRADED_EXPERIENCE,
  CometUserRoleType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER,
  CometUserRoleType.EXPERIAN_PRIVACY_POLICY,
  CometUserRoleType.EXPERIAN_TAC,
  CometUserRoleType.EXPERIAN_WRITTEN_CONSENT,
  CometUserRoleType.EXPERIAN_WRITTEN_CONSENT_LANDLORD,
  CometUserRoleType.EXPERIAN_WRITTEN_CONSENT_RENTER,
  CometUserRoleType.FEATURES_BETA,
  CometUserRoleType.FEATURES_BETA_TAC,
  CometUserRoleType.HOUSING_CONNECTOR,
  CometUserRoleType.IMPERSONATE,
  CometUserRoleType.LADMIN,
  CometUserRoleType.LADMIN_ADMIN,
  CometUserRoleType.LADMIN_CONSUMER_CARE,
  CometUserRoleType.LADMIN_LAWYER,
  CometUserRoleType.LADMIN_SALES,
  CometUserRoleType.LDQ_MARKETING_USER,
  CometUserRoleType.LDQ_TIER_TWO_AND_THREE_USER,
  CometUserRoleType.LEASING_BETA,
  CometUserRoleType.MANAGE_ROLES,
  CometUserRoleType.MARK_USERS_EMAIL_VERIFIED,
  CometUserRoleType.MULTIFAMILY_CUSTOMER,
  CometUserRoleType.NON_ADVERTISER_CUSTOMER,
  CometUserRoleType.NUCLEUS_CUSTOMER,
  CometUserRoleType.PAYMENTS_BETA,
  CometUserRoleType.PLAID_TAC,
  CometUserRoleType.POSTING_PATH_ADMIN,
  CometUserRoleType.PREMIUM_CUSTOMER,
  CometUserRoleType.PROPERTY_MANAGER_ADD_PROPERTY,
  CometUserRoleType.PROPERTY_MANAGER_ALL_PROPERTIES,
  CometUserRoleType.PROPERTY_MANAGER_COMPANY_ADMIN,
  CometUserRoleType.PROPERTY_MANAGER_COMPANY_USER,
  CometUserRoleType.PROPERTY_MANAGER_PAY_INVOICE,
  CometUserRoleType.PROPERTY_MANAGER_RESPOND_TO_REVIEW,
  CometUserRoleType.PROPERTY_MANAGER_UPDATE_LISTING,
  CometUserRoleType.PROPERTY_MANAGER_VIEW_ANALYTICS,
  CometUserRoleType.PROPERTY_MANAGER_VIEW_INVOICE,
  CometUserRoleType.PROPERTY_MANAGER_VIEW_MESSAGE,
  CometUserRoleType.ROCKET_SHIP_CUSTOMER,
  CometUserRoleType.SELF_SERVE_CUSTOMER,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_ALLOWED,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_COMET_FEATURES_RESTRICTED,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ACCESS_COMET_FEATURES,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_GRANTED_ADD_LISTING,
  CometUserRoleType.SINGLE_FAMILY_ENTERPRISE_CUSTOMER_ZRM_MANUAL_LISTING,
  CometUserRoleType.SINGLE_FAMILY_LEGACY,
  CometUserRoleType.SPOTLIGHT_CUSTOMER,
  CometUserRoleType.TERMS_ACCEPTED_STRIPE,
  CometUserRoleType.TERMS_ZILLOW_RENTAL_USER,
  CometUserRoleType.ZILLOW_RENTAL_PLAID_CHECK_TERMS,
  CometUserRoleType.ZILLOW_TAC,
] as const;
